// frontend/src/admin/blockforms/HtmlForm.js
import React, { useState, useEffect } from 'react';
import { buildBlockSave } from './blockSaveTarget';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const HtmlForm = ({ level, entityId, section, editingBlock, nextOrderIndex, onSaved, onCancel }) => {
    const existing = editingBlock?.content_data || {};

    const [htmlEn, setHtmlEn] = useState(existing.en?.content || '');
    const [htmlHi, setHtmlHi] = useState(existing.hi?.content || '');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [htmlEn, htmlHi]);

    const handleSave = async () => {
        if (!htmlEn.trim()) {
            setError('Please enter HTML code (English)');
            return;
        }
        setError(null);
        setSaving(true);

        const content_data = { en: { content: htmlEn } };
        if (htmlHi) {
            content_data.hi = { content: htmlHi };
        }

        const { url, method, payload } = buildBlockSave({
            level, entityId, section, editingBlock,
            blockType: 'html',
            contentData: content_data,
            orderIndex: nextOrderIndex,
        });

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.detail || 'Save failed');
            }
            onSaved();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ace-form">
            <h4>{editingBlock ? 'Edit' : 'Add'} HTML</h4>
            {error && <div className="ace-error">{error}</div>}

            <label>HTML Code (English) *</label>
            <textarea rows={8} value={htmlEn} onChange={(e) => setHtmlEn(e.target.value)} />

            <label>HTML Code (Hindi, optional)</label>
            <textarea rows={8} value={htmlHi} onChange={(e) => setHtmlHi(e.target.value)} />

            <div className="ace-form-actions">
                <button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                <button onClick={onCancel} className="ace-cancel-btn">Cancel</button>
            </div>
        </div>
    );
};

export default HtmlForm;